import { Link } from "@tanstack/react-router";
import { Topbar } from "../Topbar";
import { Footer } from "../Footer";
import { Hero } from "../Hero";
import { pathMap, type Locale } from "@/lib/locale";
import { listTier1Entries } from "@/lib/glossary";

export function GlossaryNotFound({ locale }: { locale: Locale }) {
  const isEn = locale === "en";
  const overviewPath = isEn ? pathMap.glossary.en : pathMap.glossary.de;
  const tr = isEn
    ? {
        eyebrow: "Glossary",
        breadHome: "Start",
        breadGlossary: "Glossary",
        title: "Entry not found",
        lead: "The glossary entry you were looking for doesn't exist (anymore). The full overview might help.",
        backAll: "All glossary entries",
        suggestionsHead: "Frequently consulted entries",
      }
    : {
        eyebrow: "Glossar",
        breadHome: "Start",
        breadGlossary: "Glossar",
        title: "Eintrag nicht gefunden",
        lead: "Den gesuchten Glossar-Eintrag gibt es nicht (mehr). Vielleicht hilft die Übersicht aller Einträge weiter.",
        backAll: "Zur Glossar-Übersicht",
        suggestionsHead: "Häufig konsultierte Einträge",
      };

  const suggestions = listTier1Entries().slice(0, 8);

  return (
    <>
      <Topbar />
      <main id="main">
        <Hero
          variant="short"
          number="404"
          eyebrow={tr.eyebrow}
          headline={tr.title}
          lead={tr.lead}
          breadcrumbs={[
            { label: tr.breadHome, to: isEn ? "/en" : "/" },
            { label: tr.breadGlossary, to: overviewPath },
            { label: "404" },
          ]}
        />
        <section className="bg-white py-20">
          <div className="mx-auto max-w-[1200px] px-6 md:px-12">
            <Link
              to={overviewPath}
              className="inline-block rounded-md border border-rule px-5 py-3 font-mono text-xs uppercase tracking-[0.18em] text-ink hover:border-cyan-deep/40 hover:text-cyan-deep"
            >
              → {tr.backAll}
            </Link>

            <h2 className="mt-16 mb-5 font-mono text-xs uppercase tracking-[0.18em] text-ink-4">
              {tr.suggestionsHead}
            </h2>
            <ul className="grid gap-3 md:grid-cols-2">
              {suggestions.map((r) => (
                <li key={r.id}>
                  <Link
                    to={`${overviewPath}/${r.slug[locale]}`}
                    className="group block rounded-md border border-rule bg-white p-4 transition-colors hover:border-cyan-deep/40"
                  >
                    <div className="font-display text-base text-ink group-hover:text-cyan-deep">
                      {r.term[locale]}
                    </div>
                    <div className="mt-1 line-clamp-2 text-sm text-ink-3">
                      {r.shortDefinition[locale]}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
